import genericStore from "../generic_store";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "type_spots",
    object: "type_spot",
    header: [
      { text: "Nombre", value: "name" },
      { text: "Descripcion", value: "description" },
      { text: "Tipo", value: "type" },
      { text: "Imagen", value: "picture", sortable: false },
      { text: "Acciones", value: "actions", sortable: false }
    ]
  },
  mutations: {
    ...genericStore.mutations
  },
  actions: {
    ...genericStore.actions
  },
  getters: {
    ...genericStore.getters
  }
};
